















import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { SocialLink } from './Footer';
/**
 * `SocialSection Footer` - SocialSection for OneWeb - This component contains the links for the social networks.
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-social-section',
  props: {
    datajson: {
      type: String,
      required: true,
    },
  },
  computed: {
    socialLinks: function(): SocialLink[] {
      return JSON.parse(this.datajson) || [];
    },
  },
});
